import Base from './Base'

class AlbumService extends Base {
  /**
   * 根据条件查询专辑列表
   *
   * @see http://tapd.oa.com/tme_music_lib/markdown_wikis/view/#1020369272008741659@toc51
   * @param {Object} query
   * @returns {Array<Tag>}
   */
  find(query) {
    return this.post('album/query_album', query, { noEmpty: true })
  }

  /**
 * 根据 ID 查找专辑详细信息
 *
 * @see http://tapd.oa.com/tme_music_lib/markdown_wikis/view/#1020369272008741659@toc59
 * @param {Object} data
 */
  findById(data) {
    return this.post('album/query_album_detail_by_id', data)
  }

  /**
 *
 * @see http://tapd.oa.com/tme_music_lib/markdown_wikis/view/#1020369272008741659@toc66
 * @param {Object} data 专辑信息
 */
  save(data, fetchTime) {
    return this.post('album/save_album?fetch_time=' + encodeURIComponent(fetchTime), data)
  }

  /**
   * 给平台发送邮件
   *
   * @see http://impai.tmeoa.com/project/5238/interface/api/49238
   * @param {Object} postData
   */
  sendPlatformMail(postData) {
    return this.post('album/send_plat_email', postData)
  }

  batchDownload(postData) {
    return this.post('album/download', postData)
  }

  // 保存修改审核记录
  applyModifyTrack(postData) {
    return this.post('review/save_track_modify_review', postData)
  }

  // 查询修改审核记录
  queryModifyTrack(postData) {
    return this.post('review/query_track_modify_review', postData, { noEmpty: true })
  }

  // 通过/拒绝
  reviewModifyTrack(postData) {
    return this.post('review/review_track_modify', postData)
  }

  // 修改审核记录，目前用于取消
  reviewEditReview(postData) {
    return this.post('review/edit_track_modify_review', postData)
  }

  // 转移
  transReviewType(postData) {
    return this.post('review/move_track_modify', postData)
  }

  applyModifyAlbum(postData) {
    return this.post('review/save_album_modify_review', postData)
  }

  queryModifyAlbum(postData) {
    return this.post('review/query_album_modify_review', postData, { noEmpty: true })
  }

  reviewModifyAlbum(postData) {
    return this.post('review/review_album_modify', postData)
  }

  reviewEditAlbumReview(postData) {
    return this.post('review/edit_album_modify_review', postData)
  }

  transAlbumReviewType(postData) {
    return this.post('review/move_album_modify', postData)
  }

  // 校验修改敏感词
  checkModifySensitive(postData) {
    return this.post('review/safe_word_check', postData)
  }

  /**
   *
   * @param {Object} data 专辑信息
   */
  aiSave(data, fetchTime) {
    return this.post('album/ai_save_album?fetch_time=' + encodeURIComponent(fetchTime), data)
  }
}

export default new AlbumService()
